import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/learn/gamified')({
  component: () => <PageStub title="Gamified Learning" description="Earn points and badges as you learn" />,
});
